<ng-container *transloco="let t">
  <div [style.padding-bottom]="paddingBottom">
  <div class="empty-state"
       [style.background-color]="backgroundColor"
       [class.box-shadow]="hasBoxShadow">
    <div class="d-flex flex-column align-items-center justify-content-center p-3" [ngClass]="hasPadding ? 'p-md-5' : ''">
      @if (imgSrc) {
        <div class="empty-state-icon d-flex justify-content-center align-items-center">
          <img src="assets/icons/icons-alt/{{imgSrc}}" alt="Icon"/>
        </div>
      }
      @if (titleKey) {
        <h1 class="text-cente pb-2">{{ t(titleKey ?? 'emptyState.sorry') }}</h1>
      }
      @if (contentKeys.length > 0) {
        @for (key of contentKeys; track key) {
          <p class="medium text-center pb-2">{{ t(key) }}</p>
        }
      }
      @if (contentKeysSecondary.length > 0) {
        @for (key of contentKeysSecondary; track key) {
          <p class="fw-400 fs-14 color-slate-600 text-center pb-2">{{ t(key, contentKeysSecondaryParams) }}</p>
        }
      }
      @if (contentKeys.length === 0 && contentKeysSecondary.length === 0) {
        <p class="medium text-center">{{ t('emptyState.not.able.to.find') }}</p>
        <p class="medium text-center">{{ t('emptyState.do.not.worry') }}</p>
        <p class="medium text-center" [innerHTML]="formattedMessage"></p>
      }
      @if (buttonText) {
        <div class="mt-2">
          <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [buttonHeight]="'36px'"
                          [fontWeight]="'400'" [text]="t(buttonText)"
                          [borderColor]="'var(--teal-500)'" [fontSize]="'14px'"
                          (onClickCallback)="onButtonClick.emit()"></app-button-alt>
        </div>
      }
    </div>
  </div>
  </div>
</ng-container>
